// FUTURE-DATE-001 (Aug 2026) — no fulfillment date may be after "today"
// in the business timezone (America/New_York). String compare on ISO dates.
import { BUSINESS_TIMEZONE } from './timezone';

export const getBusinessToday = () => new Intl.DateTimeFormat('en-CA', {
  timeZone: BUSINESS_TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const isFutureDate = (v) => !!v && ISO_DATE_RE.test(String(v).trim()) && String(v).trim() > getBusinessToday();

export const futureDateClass = (v) => (isFutureDate(v) ? ' !border-red-400 !ring-2 !ring-red-500/10' : '');

export const FutureDateError = ({ value }) => (
  isFutureDate(value)
    ? <p className="mt-1 text-[11px] font-medium text-red-600" data-testid="future-date-error">Future dates are not allowed.</p>
    : null
);
